import { render, staticRenderFns } from "./CoffeeBreakIcon.vue?vue&type=template&id=6dd4d3b6&"
import script from "./CoffeeBreakIcon.vue?vue&type=script&lang=ts&"
export * from "./CoffeeBreakIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports